import { useCallback, useEffect, useState } from "react";

const API =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
    ? "http://localhost:8001"
    : `${window.location.protocol}//${window.location.hostname}/api`;

export default function useContentPermissions(moduleKey) {
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    const loadPermissions = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await fetch(`${API}/content-permissions`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`content_permissions_${response.status}`);
        }

        const data = await response.json();

        if (alive) {
          setPermissions(
            data && typeof data === "object"
              ? data[moduleKey] || {}
              : {}
          );
        }
      } catch {
        // API hatasında eski ekran davranışı korunur:
        // kayıt olmayan içerikler görünür kalır.
        if (alive) setPermissions({});
      } finally {
        if (alive) setLoading(false);
      }
    };

    loadPermissions();

    return () => {
      alive = false;
    };
  }, [moduleKey]);

  const canView = useCallback(
    (itemKey, defaultVisible = true) => {
      if (!Object.prototype.hasOwnProperty.call(permissions, itemKey)) {
        return defaultVisible;
      }

      return permissions[itemKey] === true;
    },
    [permissions]
  );

  return {
    permissions,
    loading,
    canView,
  };
}
